import { reportMykissError } from '../../../../../../../helpers/errorHandling';

export const handleStandardAuthError = (error: any): string => {
  const emailAlreadyTakenError =
    'An account with the given email might already exist. Please check if you created your account using Google, Facebook, or Apple.';

  if (error && 'code' in error) {
    if (error.code === 'InvalidPasswordException') {
      return 'Your password must be at least 8 characters long.';
    }
    if (error.code === 'UsernameExistsException') {
      return emailAlreadyTakenError;
    }
    if (error.code === 'InvalidParameterException') {
      return 'The email you provided was invalid.';
    }
    if (
      error.code === 'UserLambdaValidationException' &&
      (error.message === 'PreSignUp failed with error User already exists.' ||
        error.message ===
          'PreSignUp failed with error {"code":2001,"message":"User already exists"}.')
    ) {
      reportMykissError(error, undefined, 'info');
      return emailAlreadyTakenError;
    }
    if (
      error.code === 'UserLambdaValidationException' &&
      error.message === 'PreSignUp failed with error {"code":2104,"message":"Bad email provider"}.'
    ) {
      return 'Bad email provider. Try using another email.';
    }
    if (error.code === 'UserLambdaValidationException') {
      return 'Something went wrong with the email validation process. Try using another email.';
    }

    reportMykissError(error);
    return error.message;
  }

  reportMykissError(error);
  return 'Something went wrong, please contact support if the issue continues.';
};
